function isTextTruncated(element) {
  // Check if content is truncated horizontally
  var isWidthTruncated = element.scrollWidth > element.clientWidth;

  // Check if content is truncated vertically
  var isHeightTruncated = element.scrollHeight > element.clientHeight;
  return isWidthTruncated || isHeightTruncated;
}

export { isTextTruncated as default };
//# sourceMappingURL=is-text-truncated.esm.js.map
